// extracted by mini-css-extract-plugin
module.exports = {"sidebarWidth":"50","editorToolbarHeight":"62","timelineHeight":"350","timelineOffsetLeft":"105","timelineSliderHeight":"35"};